<template>
<div class="backBox" >
  <el-container ref="container" style="width:85%;height:100%;margin:0 auto;">
  <el-header style="margin-top:3%">
    <div style="font-size:20px;line-height:60px;justify-content: center;display: flex;"
    >公司简介</div></el-header>
  <el-main style="justify-content: flex-start;display: flex;flex-direction:column;overflow-y: auto;">
    <div class="textgsjj" style="align-self: flex-start;">上海瀛海燃气有限责任公司成立于一九九五年四月十九日，注册资金为人民币壹仟万元，经营范围主要为液化石油气、钢瓶、灶具、热水器、餐具批发零售及维修服务，液化石油气存储、充装，液化气钢瓶检测等。公司分布在崇明全岛各乡镇和农场有二十八个液化气供应站，已拥有单位及居民用户近十万户，年销售液化石油气伍仟多吨。</div>
    <div class="textgsjj">公司具有上海市城乡建设和管理委员会颁发的《燃气经营许可证》和上海市质量技术监督局颁发的《中华人民共和国特种设备检验检测机构核准证（气瓶检验机构）》的企业，主要从事瓶装液化石油气的存储、充装和气瓶的检测等。公司具有上海市燃气经营供气许可证，公司总部及所属各液化石油气供应站均被原上海市市政局评为“规范服务达标单位”，公司所属有五个液化气供应站被评为燃气行业“新风窗口”。由于我公司特别重视对用户的安全服务工作，我公司被崇明县技术监督管理局评为“质量计量合格单位”。</div>
</el-main>
  <div style="margin-bottom:20px;height1:250px;flex:bottom">
      <el-divider @click="mytest">关注我们25-{{cWidth}}</el-divider>
      <div style="display: flex;flex-wrap: wrap;justify-content:space-between;width:100%;">
          <el-card v-if="cWidth<700" :body-style="{ padding: '2px' }" style="padding:0;max-width:600px;min-width:200px;width:100%;background: #07c160;">
            <el-image :src="require('../Images/scanhh.png')" class="image"/>
          </el-card>
          <el-card v-if="cWidth>=700" :body-style="{ padding: '2px' }" style="padding:0;max-width:450px;min-width:250px;width:40%;background: #07c160;">
            <el-image :src="require('../Images/scangzh.png')" class="image"/>
          </el-card>
          <el-card v-if="cWidth>=700" :body-style="{ padding: '2px' }" style="max-width:450px;min-width:250px;width:40%;background: #f7f7f7;">
            <el-image :src="require('../Images/scanmp.png')" class="image"/>
          </el-card>
    </div>
  </div>
  </el-container>
</div>  
    
</template>

<script>


export default {
  data() {
    return {
      cWidth1:1,
      cHeight:1,
    }
  },
  watch:{

  },
  computed: {
    cWidth(){
      return this.$store.getters.GettabBarInfo("tabBarWidth")
    },
  },
  mounted(){
    window.onresize = () => {
      //this.clientCalc();
    };
    //loadBMap('8ktYGStGratzruLRGVenOKpM7gAn39d6') // 加载引入BMap
  },
  methods: {
    mytest(){
      //this.$store.commit("SetPrmitlistRefr");
      this.$store.commit("SetRefrshItem","PrmitlistRefr");
      console.log(this.$store.getters.GetRefrshItem("PrmitlistRefr"))
    },
    clientCalc() {
      if (this.$refs.container){
      this.cWidth=this.$refs.container.getBoundingClientRect().width;
      this.cHeight=this.$refs.container.getBoundingClientRect().height;
      //this.cWidth=this.$refs.container.offsetWidth;//document.body.clientWidth;
      //this.cHeight=this.$refs.container.offsetHeight;//document.body.clientHeight;
      console.log("clientCalc",this.cWidth,this.cHeight)
      }
    },
  },
  created() {
    this.clientCalc();
  },
};
</script>
<!--公共样式(或者是width: 0;)-->
<style scoped>
.backBox {
  background: url(../Images/A1Copy.png);
  width: 100%;
  height: 100%;
  background-size: cover;
}
/* .backBox ::-webkit-scrollbar{
display:none;
} */
  .image {
    width: 100%;
    /* box-shadow: 3px 3px 3px rgba(170,170,170,.5);
		-moz-box-shadow: 3px 3px 3px rgba(170,170,170,.5);
    -webkit-box-shadow: 3px 3px 3px rgba(170,170,170,.5); */
  }
  .el-main{
    padding:0;
  }
.textgsjj{
  text-indent:2em;
  font-size: 32rpx;
  font-weight: 500;
  line-height: 42rpx;
  width:100%;
  margin:0 auto;
}
</style>